<div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">

  <button [mat-dialog-close]="true" fxFlexAlign="end" type="button" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>

  <span>{{"ENTER_SMS_CODE_FOR_PAYMENT" | translate}}</span>

  <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 6, allowNumbersOnly: true }"></ng-otp-input>

  <button mat-flat-button color="primary" class="my-button" (click)="onComplete()">{{"CONTINUE" | translate}}</button>
</div>